import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type OpenCourtCaseMutationVariables = Types.Exact<{
  input: Types.OpenCourtCaseInput
}>

export type OpenCourtCaseMutation = { __typename?: 'Mutation'; openCourtCase: boolean }

export const OpenCourtCaseDocument = gql`
  mutation OpenCourtCase($input: OpenCourtCaseInput!) {
    openCourtCase(input: $input)
  }
`
export type OpenCourtCaseMutationFn = ApolloReactCommon.MutationFunction<
  OpenCourtCaseMutation,
  OpenCourtCaseMutationVariables
>
export function useOpenCourtCaseMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    OpenCourtCaseMutation,
    OpenCourtCaseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<OpenCourtCaseMutation, OpenCourtCaseMutationVariables>(
    OpenCourtCaseDocument,
    options
  )
}
export type OpenCourtCaseMutationHookResult = ReturnType<typeof useOpenCourtCaseMutation>
export type OpenCourtCaseMutationResult = ApolloReactCommon.MutationResult<OpenCourtCaseMutation>
export type OpenCourtCaseMutationOptions = ApolloReactCommon.BaseMutationOptions<
  OpenCourtCaseMutation,
  OpenCourtCaseMutationVariables
>
